const features = {
  algolia_sorting: false, // FEATURE_TOGGLE 2025/08/14 @rapidash
  ccg_page_description: true, // FEATURE_TOGGLE 2025/08/14 @rapidash
  brand_page_aggregate_offers: true, // FEATURE_TOGGLE 2025/08/14 @rapidash
  brand_page_related_offers: true, // FEATURE_TOGGLE 2025/08/14 @rapidash
  ccg_category_page: true, // FEATURE_TOGGLE 2025/08/14 @rapidash
  brand_page_breadcrumb: true, // FEATURE_TOGGLE 2025/08/14 @rapidash
  instore_offers: true, // FEATURE_TOGGLE 2025/08/14 @rapidash
  instore_modal_barcode: true, // FEATURE_TOGGLE 2025/08/14 @rapidash
  accessibility_page: true, // FEATURE_TOGGLE 2025/08/14 @rapidash
  server_side_traces: true, // FEATURE_TOGGLE 2025/09/30 @platform Open Telemetry integration
  client_side_traces: true, // FEATURE_TOGGLE 2025/09/30 @platform Open Telemetry integration
  client_side_metrics: true // FEATURE_TOGGLE 2025/09/30 @platform Open Telemetry integration
}

export default features
